// extracted by mini-css-extract-plugin
export default {"link":"ForgotPassword_link__EcpVB","action":"ForgotPassword_action__0yW1j"};